class Select {
  constructor(element) {
    this.changeEvent = () => {
      let changeEvent;
      if (typeof (Event) === 'function') {
        changeEvent = new window.Event('change');
      } else {
        changeEvent = document.createEvent('Event');
        changeEvent.initEvent('change', true, true);
      }
      return changeEvent;
    };
    this.selectStatus = {
      show: 1, hide: 0,
    };
    this.parent = element;
    this.parent.classList.add('cselect--inited');
    const selectCollection = element.getElementsByTagName('select');
    const zero = 0;
    const first = 1;
    let fromValues = '';
    let toValues = '';
    let rangeTemplate = '';
    this.fromSelect = selectCollection[zero];
    if (this.fromSelect.hasAttribute('multiple')) {
      this.isMultiple = true;
      this.selectedValues = [];
      this.tmpTitle = '';
    }

    if (selectCollection.length > 1) {
      let optgroup = this.fromSelect.querySelector('optgroup');
      if (optgroup) {
        this.fromSelect.tabTitle = `<div class="cselect__col-title">${optgroup.getAttribute('label')}</div>`;
      }
      this.toSelect = selectCollection[first];
      const { selectedIndex } = this.toSelect;
      const options = [].slice.call(this.toSelect.options);
      if (selectedIndex > -1) {
        this.toSelect.value = options[selectedIndex].value;
      } else {
        this.toSelect.value = options[options.length - 1].value;
      }

      optgroup = this.toSelect.querySelector('optgroup');
      if (optgroup) {
        this.toSelect.tabTitle = `<div class="cselect__col-title">${optgroup.getAttribute('label')}</div>`;
      }
      this.isRange = true;
    }
    for (let i = 0; i < this.fromSelect.options.length; i += 1) {
      if (!this.fromSelect.options[i].disabled) {
        if (this.isMultiple) {
          fromValues += `<li class="cselect__li" data-type="from" data-value="${this.fromSelect.options[i].value}">
          <div class="cselect__checkbox">
            <label class="cselect__checkbox-label">
              <input type="checkbox" ${this.fromSelect.options[i].selected ? 'checked' : ''} value="${this.fromSelect.options[i].value}" name="${this.fromSelect.name}">
              <span>${this.fromSelect.options[i].text}</span>
            </label>
          </div>
        </li>`;
        } else if (!this.isMultiple) {
          const country = this.fromSelect.options[i].getAttribute('data-country') || false;
          if (country) {
            fromValues += `<li class="cselect__li" data-type="from" data-country="${country}" data-value="${this.fromSelect.options[i].value}">${this.fromSelect.options[i].text}</li>`;
          } else fromValues += `<li class="cselect__li" data-type="from" data-value="${this.fromSelect.options[i].value}">${this.fromSelect.options[i].text}</li>`;
        }
      }
    }
    if (this.isRange) {
      for (let i = 0; i < this.toSelect.options.length; i += 1) {
        if (!this.toSelect.options[i].disabled) {
          toValues += `<li class="cselect__li" data-type="to" data-value="${this.toSelect.options[i].value}">${this.toSelect.options[i].text}</li>`;
        }
      }
      rangeTemplate = `<div class="cselect__col">
            <ul class="cselect__col-list">${toValues}</ul>
          </div>`;
    }
    let titleTempl = `<span>${this.getTitle()}</span>`;
    const itemprop = this.fromSelect.getAttribute('itemprop');
    if (itemprop) {
      titleTempl = `<span itemprop="${itemprop}">${this.getTitle()}</span>`;
    }
    const template = `<div class="cselect">
        <div class="cselect__title">
          ${titleTempl}
          <svg class="cselect__title-ico svg-overlap" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L5 5L9 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="cselect__popup">
          <div class="cselect__col ${!this.isRange ? 'cselect__col--max-width' : ''}">
            ${this.fromSelect.tabTitle ? this.fromSelect.tabTitle : ''}
            <div class="cselect__col-list-wrp">
              <ul class="cselect__col-list">${fromValues}</ul>
            </div>
          </div>
          ${rangeTemplate}
        </div>
      </div>`;

    element.insertAdjacentHTML('beforeend', template);

    this.select = element.querySelector('.cselect');
    const theme = this.fromSelect.getAttribute('data-color');
    if (theme) {
      this.select.classList.add(`cselect--${theme}`);
    }
    const extClass = this.fromSelect.getAttribute('data-class');
    if (extClass) {
      this.select.classList.add(`${extClass}`);
    }
    this.popup = element.querySelector('.cselect__popup');
    this.actionsBtns = [].slice.call(element.getElementsByTagName('li'));
    if (this.isMultiple) {
      this.select.classList.add('cselect--multiple');
      this.checkboxes = Array.from(this.select.querySelectorAll('.cselect__checkbox'));
    }

    this.actionsBtns.forEach((btn) => {
      if (this.isMultiple) {
        const checkbox = btn.querySelector('input');
        checkbox.addEventListener('change', () => {
          this.multipleSet();
        });
      } else {
        btn.addEventListener('click', (evt) => {
          if (!btn.classList.contains('cselect__li--disabled')) {
            this.set(evt);
          }
        }, false);
      }
    });

    element.addEventListener('click', () => {
      if (this.status === this.selectStatus.show) {
        this.setPopupStatus(this.selectStatus.hide);
      } else {
        this.setPopupStatus(this.selectStatus.show);
      }
    }, false);

    document.body.addEventListener('click', (e) => {
      const target = e.target || e.srcElement;
      if (target !== element && !this.isChildOf(target, element)) {
        this.setPopupStatus(this.selectStatus.hide);
      }
    }, false);

    this.title = element.querySelector('.cselect__title span');
    if (element.hasAttribute('data-title')) {
      this.selectValue = document.createElement('span');
      this.selectValue.className = 'cselect__title-add';
      this.selectValue.textContent = element.getAttribute('data-title');
      this.title.parentElement.appendChild(this.selectValue);
    }
    if (this.isRange) {
      const inputs = [].slice.call(this.popup.querySelectorAll('.cselect__input'));
      inputs.forEach((input) => {
        input.addEventListener('click', evt => evt.stopPropagation());
        input.addEventListener('change', evt => this.setInput(evt), false);
      });
    }
    if (!this.isMultiple) this.reDraw();
  }

  isChildOf(child, parent) {
    let result;
    if (child.parentNode === parent) {
      result = true;
    } else if (child.parentNode === null) {
      result = false;
    } else {
      result = this.isChildOf(child.parentNode, parent);
    }
    return result;
  }

  multipleSet() {
    if (this.checkboxes && this.checkboxes.length !== 0) {
      this.checkboxes.forEach((checkbox) => {
        checkbox.input = checkbox.querySelector('input');
        checkbox.text = checkbox.querySelector('.cselect__checkbox-label span').innerHTML;
      });
      this.selectedTitles = this.checkboxes.filter(el => el.input.checked).map(el => el.text);
      this.selectedValues = this.checkboxes.filter(el => el.input.checked)
        .map(el => el.input.value);
      this.title.innerText = this.selectedTitles.join(',');
    }

    this.fromSelect.value = this.selectedValues;
    if (this.selectedValues.length === 0) {
      this.title.innerText = this.fromSelect.options[0].text;
      this.fromSelect.value = this.fromSelect.options[0].value;
    }
    Array.from(this.fromSelect.options).forEach((tmp) => {
      const option = tmp;
      option.selected = this.selectedValues.includes(option.value);
    });
    this.fromSelect.dispatchEvent(this.changeEvent());
  }

  set(evt) {
    const element = evt.target;
    let source;
    if (element.dataset.type === 'from') {
      source = this.fromSelect;
      if (this.isRange) {
        if (this.fromSelect) {
          this.fromSelect.value = element.dataset.value;
          this.fromSelect.dispatchEvent(this.changeEvent());
        }
      }
    } else if (element.dataset.type === 'to') {
      source = this.toSelect;
      if (this.toSelect) {
        // const opts = [].slice.call(this.toSelect.options);
        // this.toSelect.value = element.dataset.value;
        // opts.forEach((opt) => {
        //   opt.selected = opt.value === this.toSelect.value;
        // });
        this.toSelect.dispatchEvent(this.changeEvent());
      }
    }
    const oldValue = source.value;
    source.value = element.dataset.value;
    if (this.isRange) {
      if (parseFloat(this.fromSelect.value) > parseFloat(this.toSelect.value)) {
        source.value = oldValue;
      }
    }
    if (source.value !== oldValue) {
      source.dispatchEvent(this.changeEvent());
      if (this.isRange && source === this.toSelect) {
        this.setPopupStatus(this.selectStatus.hide);
      }
      if (!this.isRange) {
        this.reDraw();
        this.setPopupStatus(this.selectStatus.hide);

        if (this.parent.hasAttribute('data-title')) {
          this.title.appendChild(this.selectValue);
        }
      }
    }
    if (this.isRange) {
      this.changeSelected(element);
    }
    evt.stopPropagation();
  }

  changeSelected(el) {
    const allOptions = this.parent.querySelectorAll('li:not([data-value=""])');
    for (let k = 0; k < allOptions.length; k += 1) {
      const option = allOptions[k];
      let { value } = option.dataset;
      if (value.indexOf('+') !== -1) {
        value = value.substr(0, value.length - 1);
      }

      if (option.dataset.type === 'from') {
        if (parseFloat(value) > parseFloat(this.toSelect.value)) {
          option.classList.add('cselect__li--disabled');
        } else {
          option.classList.remove('cselect__li--disabled');

          if (parseFloat(value) === parseFloat(this.fromSelect.value)) {
            option.classList.add('cselect__li--active');
          } else {
            option.classList.remove('cselect__li--active');
          }
        }
      }

      if (option.dataset.type === 'to') {
        if (parseFloat(value) < parseFloat(this.fromSelect.value)) {
          option.classList.add('cselect__li--disabled');
        } else {
          option.classList.remove('cselect__li--disabled');

          if (parseFloat(value) === parseFloat(this.toSelect.value)) {
            option.classList.add('cselect__li--active');
          } else {
            option.classList.remove('cselect__li--active');
          }
        }
      }
    }

    if (el.dataset.type === 'from') {
      const options = this.parent.querySelectorAll('li[data-type="from"]');
      const lastElement = options[options.length - 1];
      const firstElement = options[0];
      let lastValue = lastElement.dataset.value;
      if (lastValue.indexOf('+') !== -1) {
        lastValue = lastValue.substr(0, lastValue.length - 1);
      }

      if (this.fromSelect.value.length === 0) {
        firstElement.classList.add('cselect__li--active');
        this.fromSelect.value = firstElement.dataset.value;
      } else if (this.fromSelect.value.length !== 0) {
        if ((parseFloat(this.fromSelect.value) > parseFloat(this.toSelect.value)) &&
          (parseFloat(this.toSelect.value) <= parseFloat(lastValue))) {
          this.fromSelect.value = this.toSelect.value;
          this.fromSelect.dispatchEvent(this.changeEvent());
          this.toSelect.dispatchEvent(this.changeEvent());
        } else if ((parseFloat(this.fromSelect.value) < parseFloat(this.toSelect.value)) &&
          (parseFloat(this.fromSelect.value) >= parseFloat(lastValue))) {
          lastElement.classList.add('cselect__li--active');
          this.fromSelect.value = lastValue;
          this.fromSelect.dispatchEvent(this.changeEvent());
          this.toSelect.dispatchEvent(this.changeEvent());
        } else if ((parseFloat(this.fromSelect.value) > parseFloat(this.toSelect.value)) &&
          (parseFloat(this.fromSelect.value) > parseFloat(lastValue))) {
          lastElement.classList.add('cselect__li--active');
          this.fromSelect.value = lastValue;
          this.fromSelect.dispatchEvent(this.changeEvent());
        }
      }
    }

    if (el.dataset.type === 'to') {
      const options = this.parent.querySelectorAll('li[data-type="to"]');
      const lastElement = options[options.length - 1];
      let lastValue = lastElement.dataset.value;
      if (lastValue.indexOf('+') !== -1) {
        lastValue = lastValue.substr(0, lastValue.length - 1);
      }

      if (this.toSelect.value.length === 0 ||
        parseFloat(this.toSelect.value) > parseFloat(lastValue)) {
        this.toSelect.value = lastElement.dataset.value;
        this.toSelect.dispatchEvent(this.changeEvent());
        lastElement.classList.add('cselect__li--active');
      }
    }
    this.title.innerText = this.getTitle();
  }

  reDraw() {
    const options = this.parent.querySelectorAll('li:not([data-value=""])');
    for (let i = 0; i < options.length; i += 1) {
      const option = options[i];
      option.classList.remove('cselect__li--active');
      if (option.dataset.type === 'from') {
        if (this.isRange &&
          parseFloat(option.dataset.value) > parseFloat(this.toSelect.value)) {
          option.classList.add('cselect__li--disabled');
        } else {
          option.classList.remove('cselect__li--disabled');
          if (parseFloat(option.dataset.value) === parseFloat(this.fromSelect.value)) {
            option.classList.add('cselect__li--active');
          }
          if (typeof option.dataset.value === 'string') {
            if (option.dataset.value === this.fromSelect.value) {
              option.classList.add('cselect__li--active');
            }
          }
        }
      }
      if (option.dataset.type === 'to') {
        let { value } = option.dataset;
        if (value.indexOf('+') !== -1) {
          value = value.substr(0, value.length - 1);
        }
        if (parseFloat(value) < parseFloat(this.fromSelect.value)) {
          option.classList.add('cselect__li--disabled');
        } else {
          option.classList.remove('cselect__li--disabled');
          if (parseFloat(value) === parseFloat(this.toSelect.value)) {
            option.classList.add('cselect__li--active');
          }
        }
      }
    }
    this.title.innerText = this.getTitle();
  }

  getTitle() {
    let title;
    if (this.isMultiple) {
      const selectedValues = Array.from(this.fromSelect.options)
        .filter(el => !el.disabled).filter(el => el.selected).map(el => el.text);

      if (selectedValues.length > 1) {
        title = `${selectedValues.join(',')}`;
      } else if (selectedValues.length === 1) {
        title = `${selectedValues[0]}`;
      } else if (selectedValues.length === 0) {
        title = this.fromSelect.options[0].text;
      }
    } else {
      const { selectedIndex } = this.fromSelect;
      let textFrom = this.fromSelect.options[0].text;
      if (selectedIndex >= 0) {
        textFrom = this.fromSelect.options[selectedIndex].text;
        title = textFrom;
      } else {
        title = textFrom;
      }
      if (this.isRange) {
        const toSelectedIndex = this.toSelect.selectedIndex;
        if (selectedIndex >= 0) {
          title = `${textFrom}`;
        } else {
          title = 'от';
        }
        if (toSelectedIndex >= 0) {
          const textTo = this.toSelect.options[toSelectedIndex].text;
          title += ` — ${textTo}`;
        } else {
          title += ' — до';
        }
      }
      if (this.parent.classList.contains('select--from')) {
        if (selectedIndex >= 0) {
          title = `${textFrom}`;
        } else {
          title = 'от';
        }
      }
      if (this.parent.classList.contains('select--to')) {
        if (selectedIndex >= 0) {
          title = `${textFrom}`;
        } else {
          title = 'до';
        }
      }
    }
    return title;
  }

  setPopupStatus(status) {
    this.status = status;
    if (status === this.selectStatus.show) {
      this.title.parentElement.classList.add('cselect__title--open');
      this.popup.classList.add('cselect__popup--show');
    } else {
      this.title.parentElement.classList.remove('cselect__title--open');
      this.popup.classList.remove('cselect__popup--show');
    }
  }
}

export default Select;



// WEBPACK FOOTER //
// ./core/select/select.js